module.exports = __webpack_public_path__ + "assets/img/7.1894dde1.jpg";